export const tempService = [
  {
    code: "TRAVEL_SIM",
    name: "Sim Du lịch",
    displayCode: "TRAVEL_SIM",
  },
  {
    code: "BUY_PACKAGE",
    name: "Data 4G/5G",
    displayCode: "BUY_PACKAGE",
  },
  {
    code: "SIM_ECOMMERCE",
    name: "Sim số",
    displayCode: "SIM_ECOMMERCE",
  },
  {
    code: "AIR_TIME",
    name: "Nạp tiền điện thoại",
    displayCode: "AIR_TIME",
  },
  {
    code: "NICE_SIM",
    name: "Sim số đẹp",
    displayCode: "NICE_SIM",
  },
  {
    code: "ADD_BALANCE",
    name: "Nạp số dư",
    displayCode: "ADD_BALANCE",
  },
];
